import { useI18n } from '@/locales/useI18n';

const fy = $computed(() => useI18n().tm('mBooster.image.status'))
// Available、Disable、Building、Failed

export enum ImageStatus {
    AVAILABLE = 'Available',
    DISABLE = 'Disable',
    BUILDING = 'Building',
    FAILED = 'Failed',
}

export const StatusMap = new Map([
    [
        ImageStatus.AVAILABLE,
        {
            lable: 'Available',
            color: '#10C700',
            value: fy.available
        },
    ],
    [
        ImageStatus.DISABLE,
        {
            lable: 'Disable',
            color: '#6D6D6D',
            value: fy.disable
        },
    ],
    [
        ImageStatus.BUILDING,
        {
            lable: 'Building',
            color: '#1677ff',
            value: fy.building
        },
    ],
    [
        ImageStatus.FAILED,
        {
            lable: 'Failed',
            color: '#EA0000',
            value: fy.failed
        },
    ],
]);
